import axios from 'axios';

// PARA O APP MOBILE, O IP TEM QUE SER FIXO (USE O IP DA SUA VPS)
// PARA O APP MOBILE, O IP TEM QUE SER FIXO (USE O IP DA SUA VPS)
const API_URL = 'https://wadesk.com.br/api';

// Se for rodar local no emulador do Android Studio, use: 'http://10.0.2.2:3015/api'
// Se for rodar no celular na mesma rede Wi-Fi do PC, use o IP do PC: 'http://192.168.x.x:3015/api'

const api = axios.create({
    baseURL: API_URL,
    timeout: 10000
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            console.warn('[API] Sessão expirada ou não autorizada. Limpando sessão local.');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;